export const environment = {
  production: true,
  // API_BASE_URL: "https://api.licthailand.com",
  API_BASE_URL: "",
  authTokenKey: "token",
  authorizationCode: "Lic008Thai",
  // Feature flag: toggle page-visit tracking on/off without redeploying code.
  pageTracking: {
    enabled: true,
  },
};
